import type { ButtonProps as RACButtonProps } from 'react-aria-components'
import { Button as RACButton, composeRenderProps } from 'react-aria-components'
import tv from '~/lib/tv'

export interface ActionButtonProps extends RACButtonProps {
  icon: React.ReactNode
  isDisabled?: boolean
  bigger?: boolean
  noBack?: boolean
}

const actionButtonVariants = tv({
  base: 'group rounded-full flex items-center justify-center self-center',
  variants: {
    bigger: {
      true: 'w-12 h-12 hover:bg-gray-100 active:bg-primary-black border-2 pressed:bg-primary-black',
      false: 'p-1',
    },
    isDisabled: {
      true: 'bg-gray-20 cursor-not-allowed',
      false: 'border-2 border-gray-20 pressed:bg-primary-black',
    },
    noBack: {
      true: 'border-none',
      false: 'hover:bg-gray-100 active:bg-primary-black'
    },
  },
})

const iconVariants = tv({
  variants: {
    isDisabled: {
      true: 'fill-white',
      false: 'fill-gray-100',
    },
    noBack: {
      true: 'fill-gray-100',
      false: 'group-hover:fill-white group-active:fill-white',
    },
  },
})

export default function ActionButtons(props: ActionButtonProps) {
  return (
    <RACButton
      {...props}
      className={composeRenderProps(props.className, (className, renderProps) =>
        actionButtonVariants({
          ...renderProps,
          isDisabled: props.isDisabled,
          noBack: props.noBack,
          className,
        }),
      )}
    >
      <span className={iconVariants({ isDisabled: props.isDisabled, noBack: props.noBack })}>{props.icon}</span>
    </RACButton>
  )
}
